<div class="parent" [@slide]="activePane">
	<div class="child" [class.active]="activePane === 'left'">
		<ng-content select="[leftPane]" />
	</div>
	<div class="child" [class.active]="activePane === 'right'">
		<ng-content select="[rightPane]" />
	</div>
</div>
